package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "vi")
val ViStrings = Strings(
    analyzer = "Bộ phân tích",
    appreciationOverview = "Tổng quan về sự tăng giá",
    chartLegendInterest = "Lãi suất",
    chartLegendPrincipal = "Tiền gốc",
    chartXaxisMonths = "Tháng",
    chartYaxisPayment = "Thanh toán",
    code = "vi",
    costOfCredit = "Chi phí tín dụng",
    creditDealAnalyzerDescription = "Nhập chi tiết khoản vay của bạn để nhận phân tích toàn diện về giao dịch tín dụng của bạn. Bộ phân tích của chúng tôi đánh giá các chỉ số chính để giúp bạn hiểu chi phí thực của khoản vay và đưa ra quyết định sáng suốt.",
    detailsGoodRateLongTerm = "Lãi suất tốt nhưng thời hạn dài dẫn đến tổng chi phí cao.",
    detailsHighApr = "APR cao. ",
    detailsHighInterestCost = "Tổng chi phí lãi vay cao.",
    detailsHighRateShortTerm = "Lãi suất cao nhưng thời hạn ngắn giữ tổng chi phí thấp.",
    detailsLowApr = "APR thấp. ",
    detailsLowInterestCost = "Tổng chi phí lãi vay thấp.",
    discountsTradeIn = "Giảm giá / Đổi cũ lấy mới",
    displayName = "Tiếng Việt",
    distribution = "Phân phối",
    downPayment = "Trả trước",
    effectiveApr = "APR",
    headerBalance = "Số dư",
    headerDate = "Ngày",
    headerInterest = "Lãi suất",
    headerMonth = "#",
    headerPayment = "Thanh toán",
    headerPrincipal = "Tiền gốc",
    hideDetails = "Ẩn chi tiết",
    interest = "Lãi suất",
    invalidData = "Dữ liệu không hợp lệ",
    loanAmountSupportingText = "Tổng số tiền vay, bao gồm mọi chi phí bổ sung.",
    loanDetails = "Chi tiết khoản vay",
    paymentSupportingText = "Khoản thanh toán hàng tháng ước tính của bạn.",
    paymentComposition = "Thành phần thanh toán",
    percentSymbol = "%",
    principal = "Tiền gốc",
    ratingBad = "Giao dịch tồi",
    ratingExcellent = "Giao dịch xuất sắc",
    ratingFair = "Giao dịch công bằng",
    ratingGood = "Giao dịch tốt",
    ratingPoor = "Giao dịch kém",
    schedule = "Lịch trình",
    showDetails = "Hiển thị chi tiết",
    summaryBad = "Rất bất lợi, tránh nếu có thể.",
    summaryExcellent = "Điều kiện tài chính xuất sắc.",
    summaryFair = "Điều kiện công bằng, xem xét đàm phán.",
    summaryGood = "Điều kiện tốt, tiêu chuẩn cho thị trường.",
    summaryPoor = "Điều kiện kém, chi phí hoặc lãi suất cao.",
    totalPaid = "Tổng đã trả",
    lockTaxRate = "Khóa thuế suất",
    unlockTaxRate = "Mở khóa thuế suất",
    currencySymbol = "₫",
    currency = "Tiền tệ",
    totalCreditAmount = "Tổng số tiền tín dụng",
    taxAmount = "Số tiền thuế/khấu trừ",
    netAmountDisbursed = "Số tiền giải ngân ròng",
    years = "Năm",
    loanTermTotalMonths = "Thời hạn vay (Tháng)",
    monthlyInstallment = "Trả góp hàng tháng",
    principalInstallment = "Trả góp tiền gốc",
    otherFees = "Các khoản phí khác",
    insuranceCost = "Phí bảo hiểm",
    aprc = "Tỷ lệ phần trăm hàng năm của phí (APRC)",
    totalAmountPayable = "Tổng số tiền phải trả",
    prepaidFeeFixed = "Phí xử lý (Số tiền cố định)",
    prepaidFeePercentage = "Phí xử lý (Phần trăm)",
    months = "Tháng",
    description = "Bộ phân tích này giúp bạn đánh giá xem một đề nghị vay có thuận lợi cho bạn hay không. Không giống như các máy tính tiêu chuẩn, nó không yêu cầu nhập lãi suất. Thay vào đó, nó tính toán APR và tổng chi phí tín dụng dựa trên các khoản thanh toán và phí, cung cấp xếp hạng giao dịch và biểu đồ chi tiết.",
    agree = "Đồng ý",
    information = "Thông tin",
    errorCalculationOverflow = "APR quá cao, tràn số tính toán.",
    errorTotalPaymentIsLessThanLoanAmount = "Số tiền nhận được ít hơn số tiền vay.",
    errorDivisionByZero = "Chia cho số không",
    errorNegativeResult = "Kết quả âm",
    errorRateTooHigh = "Tỷ lệ quá cao",
    errorCalculation = "Vui lòng nhập dữ liệu chính xác",
    close = "Đóng",

    hi = "Xin chào",
    guest = "Khách",
    account = "Tài khoản",
    signInWithGoogle = "Đăng nhập bằng Google",
    signOut = "Đăng xuất",
    settings = "Cài đặt",
    about = "Giới thiệu",
    privacyPolicy = "Chính sách bảo mật",
    termsOfService = "Điều khoản dịch vụ",
    language = "Ngôn ngữ",

    theme = "Chủ đề",
    light = "Sáng",
    dark = "Tối",
    system = "Hệ thống",
    toggleExpand = "Mở rộng/Thu gọn",
)
